import { createContext, use, useMemo } from 'react';

import { useMedia } from 'react-use';

export type MatchMediaBreakpoint = 'isXs' | 'isSm' | 'isMd' | 'isLg' | 'isXl' | 'is2Xl';
type MatchMediaContext = Record<MatchMediaBreakpoint, boolean>;

const MatchMediaContext = createContext<MatchMediaContext | null>({
  isXs: false,
  isSm: false,
  isMd: false,
  isLg: false,
  isXl: false,
  is2Xl: false
});

export const MatchMediaContextProvider: React.FC<Children> = ({ children }) => {
  const isSm = useMedia('(min-width: 640px)', true);
  const isMd = useMedia('(min-width: 768px)', false);
  const isLg = useMedia('(min-width: 1024px)', false);
  const isXl = useMedia('(min-width: 1280px)', false);
  const is2Xl = useMedia('(min-width: 1536px)', false);
  const isXs = !isSm;

  const matchMediaState = useMemo(() => {
    return {
      isXs,
      isSm,
      isMd,
      isLg,
      isXl,
      is2Xl
    };
  }, [isXs, isSm, isMd, isLg, isXl, is2Xl]);

  return <MatchMediaContext value={matchMediaState}>{children}</MatchMediaContext>;
};

export const useMatchMediaContext = () => {
  const context = use(MatchMediaContext);
  if (!context) throw new Error('useMatchMediaContext must be used within a MatchMediaContextProvider');
  return context;
};
